<div class="modal-content">
    <div class="modal-header justify-content-center">
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
            <i class="nc-icon nc-simple-remove"></i>
        </button>
        <h4 class="title title-up">{{ title }}</h4>
    </div>
    <div class="modal-body" [ngClass]="{'ocult':!userPerm}">
        <div *ngIf="!loading">
            <div id="accordion" role="tablist" aria-multiselectable="true" class="card-collapse">

                <div class="card card-plain">
                    <div class="card-header" role="tab" id="headingOne">
                        <span data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true"
                            aria-controls="collapseOne">
                            Dados básicos
                        </span>
                    </div>
                    <div id="collapseOne" class="collapse show" role="tabpanel" aria-labelledby="headingOne">
                        <div class="card-body">
                            <form [formGroup]="form">
                                <div class="row align-items-center">
                                    <div class="col-md-auto mx-auto">


                                        <div class="custom-file">
                                            <input style="max-width: 100%" #file type="file" ng2FileSelect [uploader]="uploader"
                                                enctype="multipart/form-data" (change)="upload(file.files)"
                                                formControlName="arquivo" />
                                        </div>
                                        <label for="file-input">
                                        </label>
                                        <div class="col-md-9" style="margin-bottom: 40px">

                                            <h3>Baixar arquivos</h3>
                                            <p>Quantidades: {{ arquivos?.length }}</p>
                                            <hr>
                                            <table class="table" *ngIf="!loading">
                                                <thead>
                                                    <tr>
                                                        <th width="50%">Nome</th>
                                                        <th>Tipo</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr #tabela *ngFor="let item of arquivos; let indexOfelement=index;">
                                                        <td nowrap><div class="truncate"><strong>{{ item.dS_BPM_FILENAME_ARQUIVO_PATRIMONIAL
                                                                }}</strong></div></td>
                                                        <td nowrap>{{ item.dS_BPM_CONTENT_TYPE_ARQUIVO_PATRIMONIAL }}
                                                        </td>
                                                        <td nowrap>
                                                            <button type="button" class="btn btn-danger btn-xs"
                                                                (click)="remover(item.cD_BPM_ARQUIVO_PATRIMONIAL, indexOfelement)">
                                                                <span class="glyphicon glyphicon-trash"></span> 
                                                                <i class="bi bi-trash"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>

                                            </table>
                                            <div class="row">
                                                <div class="col-md-12 text-center" *ngIf="loading">
                                                    <img src="./assets/img/loading.png" class="loading"
                                                        id="loadingImage" height="50" width="50" />
                                                </div>
                                            </div>


                                        </div>

                                    </div>
                                    <hr>
                                </div>
                                
                                <div class="row ">

                                    <div class="col-md-4 mx-auto">
                                        <div class="form-group">
                                            <label for="et_pt">Nr. Patrimonio</label>
                                            <input type="text" class="form-control" id="et_pt" placeholder="NR. PATRIMONIO"
                                            formControlName="dS_BPM_ETIQUETA_BEM"
                                            [ngClass]="{
                                                'has-danger':
                                                  form.controls.dS_BPM_ETIQUETA_BEM.errors?.required &&
                                                  form.controls.dS_BPM_ETIQUETA_BEM.touched
                                              }" readonly>
                                        </div>
                                    </div>
                                    <div class="col-md-4 mx-auto">
                                        <div class="form-group">
                                            <label for="desc">Descrição *</label>
                                            <textarea class="form-control" id="desc" placeholder="Descrição" rows="3"
                                            [ngClass]="{
                                                'has-danger':
                                                  form.controls.dS_BPM_DESCRICAO_BEM.errors?.required &&
                                                  form.controls.dS_BPM_DESCRICAO_BEM.touched
                                              }"formControlName="dS_BPM_DESCRICAO_BEM"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-4 mx-auto">
                                        <!--<div class="form-group">
                                            <label for="matricula">Cautela *</label>
                                            <input type="text" class="form-control" id="matricula"
                                                placeholder="Cautela" formControlName="cD_CDU_MATRICULA_USUARIO_CAUTELA"
                                                [ngClass]="{
                                                    'has-danger':
                                                      form.controls.cD_CDU_MATRICULA_USUARIO_CAUTELA.errors?.required &&
                                                      form.controls.cD_CDU_MATRICULA_USUARIO_CAUTELA.touched
                                                  }">
                                        </div>-->
                                        <div class="form-group">
                                            <label for="cD_CDU_MATRICULA_USUARIO_CAUTELA">Cautela *</label>
                                            
                                            <ng-autocomplete 
                                                id="cD_CDU_MATRICULA_USUARIO_CAUTELA"
                                                [data]="data"
                                                [searchKeyword]="keywordMatriculaDest"
                                                [placeholder]=this.form.value.cD_CDU_MATRICULA_USUARIO_CAUTELA
                                                (selected)='selectDest($event)'
                                                [itemTemplate]="itemTemplateMatriculaDest"
                                                [notFoundTemplate]="notFoundTemplateDest"
                                                (inputChanged)='onChangeSearch($event)'
                                                (inputCleared)="clearInputDest()">                                 
                                            </ng-autocomplete>
                                            
                                              <ng-template #itemTemplateMatriculaDest let-item>
                                                <a [innerHTML]="item.nome"></a>
                                              </ng-template>
                                              
                                              <ng-template #notFoundTemplateDest let-notFound>
                                              <div [innerHTML]="notFound"></div>
                                              </ng-template>
                                        </div>
                                    </div>
                                    <!-- <div class="col-md-4 mx-auto">
                                        <div class="form-group">
                                            <label for="location">Unidade Operacional</label>
                                            <select class="form-control custom-select" id="location"
                                                formControlName="cD_BPM_NR_UNIDADE">
                                                <option value="" selected disabled>Unidade Operacional</option>
                                                <option *ngFor="let local of localizacao "
                                                    value={{local.cD_BPM_NR_UNIDADE}}>
                                                    {{local.dS_BPM_UNIDADE}}
                                                </option>
                                            </select>
                                        </div>
                                    </div> -->
                                    <div class="col-md-4 mx-auto">
                                        <div class="form-group">
                                            <label for="location">Unidade Operacional *</label>
                                            
                                                <ng-autocomplete 
                                                id="location"
                                                [data]="localizacao"
                                                [placeholder]=cadastro.dS_BPM_UNIDADE
                                                [heading]="cadastro.dS_BPM_UNIDADE"
                                                [searchKeyword]="keyword"
                                                (selected)='selectEvent($event)'
                                                (inputChanged)='onChangeSearch($event)'
                                                [itemTemplate]="itemTemplate"
                                                [notFoundTemplate]="notFoundTemplate"
                                                >                                 
                                              </ng-autocomplete>
                                              
                                              <ng-template #itemTemplate let-item>
                                              <a [innerHTML]="item.dS_BPM_UNIDADE">
                                              </a>
                                              </ng-template>
                                              
                                              <ng-template #notFoundTemplate let-notFound>
                                              <div [innerHTML]="notFound"></div>
                                              </ng-template>
                                            
                                        
                                            </div>
                                    </div>
                                    <div class="col-md-4 mx-auto">
                                        <div class="form-group">
                                            <label for="sala">Sala</label>
                                            <input type="text" class="form-control" id="sala" placeholder="Sala"
                                                formControlName="dS_BPM_SALA">
                                        </div>
                                    </div>
                                    <div class="col-md-4 mx-auto">
                                          <!-- <div class="autocomplete-box">
                                            <ul *ngFor="let lista of tipoDeBem | filter:term" class="autocomplete-list"
                                              [hidden]="listarNomes == false">
                                              
                                              <li class="d-flex" (click)="selectTipo(lista.nR_BPM_TIPO_BEM_PATRIMONIAL)">
                                                <div class="flex-column">
                                                  <p> {{ lista.dS_BPM_DESCRICAO_TIPO_BEM }}</p>
                                                </div>
                                  
                                              </li>
                                            </ul>
                                          </div> -->
                                        <div class="form-group">
                                            <label for="tipoDeBem">Tipo de bem *</label>
                                            
                                                <ng-autocomplete 
                                                id="tipoDeBem"
                                                [data]="tipoDeBem"
                                                [placeholder]=cadastro.dS_BPM_DESCRICAO_TIPO_BEM
                                                [heading]="cadastro.dS_BPM_DESCRICAO_TIPO_BEM"
                                                [searchKeyword]="keywordTipo"
                                                (selected)='selectTipo($event)'
                                                [itemTemplate]="itemTemplate2"
                                                [notFoundTemplate]="notFoundTemplate">
                                              </ng-autocomplete>
                                              
                                              <ng-template #itemTemplate2 let-item>
                                              <a [innerHTML]="item.dS_BPM_DESCRICAO_TIPO_BEM">
                                              </a>
                                              </ng-template>
                                              
                                              <ng-template #notFoundTemplate let-notFound>
                                              <div [innerHTML]="notFound"></div>
                                              </ng-template>
                                            
                                        
                                            </div>
                                    </div>
                                    <!-- <div class="col-md-4 mx-auto">
                                        <div class="form-group">
                                            <label for="tipoDeBem">Tipo de bem</label>
                                            <select class="form-control custom-select" id="tipoDeBem"
                                                formControlName="nR_BPM_TIPO_BEM_PATRIMONIAL">
                                                <option value="" selected disabled>Tipo de Bens</option>
                                                <option *ngFor="let tipo of tipoDeBem"
                                                    value={{tipo.nR_BPM_TIPO_BEM_PATRIMONIAL}}>
                                                    {{tipo.dS_BPM_DESCRICAO_TIPO_BEM}}
                                                </option>
                                            </select>
                                        </div>
                                    </div> -->
                                    <!-- <div class="col-md-4 mx-auto">
                                        <div class="form-group">
                                            <label for="depreciacao">Depreciação</label>
                                            <input type="text" class="form-control text-left" currencyMask
                                                formControlName="vL_BPM_DEPRECIACAO_BEM" id="depreciacao"
                                                placeholder="Depreciação"
                                                [options]="{ prefix: '',suffix:' %'}">
                                        </div>
                                    </div> -->
                                    <div class="col-md-4 mx-auto">
                                        <div class="form-group">
                                            <label for="nome">Valor da Contábil</label>
                                            <input type="text" class="form-control" placeholder="Valor da aquisição" currencyMask
                                            formControlName="vL_BPM_VALOR_AQUISICAO">
                                        </div>
                                    </div>
                                    <div class="col-md-4 mx-auto">
                                        <div class="form-group">
                                            <label for="nrImobi">Número do imobilizado *</label>
                                            <input type="number" 
                                            class="form-control" 
                                            placeholder="Número do imobilizado"
                                            formControlName="nR_BPM_IMOBILIZADO_TI"
                                            id="nrImobi"
                                            [ngClass]="{
                                                'has-danger':
                                                  form.controls.nR_BPM_IMOBILIZADO_TI.errors?.required &&
                                                  form.controls.nR_BPM_IMOBILIZADO_TI.touched
                                              }" required>
                                        </div>
                                    </div>
                                    <div class="col-md-4 mx-auto">
                                        <div class="form-group">
                                            <label for="nome">Número de série</label>
                                            <input type="text" class="form-control" placeholder="Número de série"
                                                formControlName="dS_BPM_NUMERO_SERIE">
                                        </div>
                                    </div>
                                    <div class="col-md-4 mx-auto">
                                        <div class="form-group">
                                            <label for="nome">Outros atributos</label>
                                            <input type="text" class="form-control" placeholder="Outros atributos"
                                                formControlName="dS_BPM_OUTROS">
                                        </div>
                                    </div>
                                    <div class="col-md-4 mx-auto">
                                        <div class="form-group">
                                            <label for="nome">Marca</label>
                                            <input type="text" class="form-control" placeholder="Marca"
                                                formControlName="dS_BPM_MARCA">
                                        </div>
                                    </div>
                                    <div class="col-md-4 mx-auto">
                                        <div class="form-group">
                                            <label for="nome">Modelo</label>
                                            <input type="text" class="form-control" placeholder="Modelo"
                                                formControlName="dS_BPM_MODELO">
                                        </div>
                                    </div>
                                    <div class="col-md-4 mx-auto">
                                        <div class="form-group">
                                            <label for="nome">Placa</label>
                                            <input type="text" class="form-control" placeholder="Placa"
                                                formControlName="dS_BPM_PLACA">
                                        </div>
                                    </div>

                                    <div class="col-md-4 mx-auto">
                                        <div class="form-group">
                                            <label for="numeroCdContrato">Origem *</label>
                                            <input type="text" class="form-control" id="numeroCdContrato"
                                                placeholder="Origem"
                                                formControlName="nR_BPM_NUMERO_CONTRATO"
                                                [ngClass]="{
                                                    'has-danger':
                                                      form.controls.nR_BPM_NUMERO_CONTRATO.errors?.required &&
                                                      form.controls.nR_BPM_NUMERO_CONTRATO.touched
                                                  }" required>

                                        </div>
                                    </div>
                                    <div class="col-md-4 mx-auto">
                                        <div class="form-group">
                                            <label for="numeroNota">Número da Nota *</label>
                                            <input type="number" class="form-control" id="numeronota"
                                                placeholder="Número da Nota"
                                                formControlName="nR_BPM_NUMERO_NOTA_FISCAL"
                                                [ngClass]="{
                                                    'has-danger':
                                                      form.controls.nR_BPM_NUMERO_NOTA_FISCAL.errors?.required &&
                                                      form.controls.nR_BPM_NUMERO_NOTA_FISCAL.touched
                                                  }" required>

                                        </div>
                                    </div>
                                    <div class="col-md-4 mx-auto">
                                        <div class="form-group">
                                            <label for="dataNota">Data da nota *</label>
                                            <input type="date" 
                                            max={{dataAtual}}
                                            class="form-control" 
                                            id="dataNota"
                                                placeholder="Data da nota"
                                                formControlName="dT_BPM_DATA_NOTA_FISCAL"
                                                [ngClass]="{
                                                    'has-danger':
                                                      form.controls.dT_BPM_DATA_NOTA_FISCAL.errors?.required &&
                                                      form.controls.dT_BPM_DATA_NOTA_FISCAL.touched
                                                  }" required>

                                        </div>
                                    </div>




                                    <div class="col-md-4 mx-auto">
                                        <label>Ativo</label>
                                        <div class="form-group text-center">
                                            <select formControlName="fL_BPM_ATIVO"
                                                class="form-control custom-select text-center" aria-label="Small">
                                                <option selected disabled>Ativo</option>
                                                <option value="1">Sim</option>
                                                <option value="0">Não</option>
                                            </select>
                                        </div>
                                    </div>
                                 
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row ">
                <div class="col-md-12 text-center " *ngIf="loading ">
                    <img src="../../../../assets/img/loading.png" class="loading" id="loadingImage" height="50 "
                        width="50 " />
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!loading" class="modal-footer">
        <div class="left-side">
            <button type="button" class="btn btn-danger btn-link" (click)="activeModal.close()">
                Cancelar
            </button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
            <button type="button" class="btn btn-success btn-link"(click)="submit()">
                Salvar
            </button>
        </div>
    </div>